import React from 'react';
import { RECENTLY_DELETED, UNDO_ACTION, UNDO_DISMISS } from '../../utils/writerCopy';

/** Quiet message. It stays until the writer dismisses it or does something else. No clock. */
export default function UndoMessage({ message, onUndo, onDismiss, onRecentlyDeleted }) {
  if (!message) return null;
  return (
    <div className="undo-msg" role="status">
      <p className="undo-msg__text">{message}</p>
      {onUndo ? (
        <button type="button" className="undo-msg__btn" onClick={onUndo}>
          {UNDO_ACTION}
        </button>
      ) : null}
      {onRecentlyDeleted ? (
        <button type="button" className="undo-msg__btn" onClick={onRecentlyDeleted}>
          {RECENTLY_DELETED}
        </button>
      ) : null}
      <button type="button" className="undo-msg__btn" aria-label={UNDO_DISMISS} onClick={onDismiss}>
        ✕
      </button>
    </div>
  );
}
